import { createFileRoute } from '@tanstack/react-router';
import { TaskResetPassword } from '@clerk/clerk-react';
import styles from '../components/Auth.module.css';

export const Route = createFileRoute('/reset-password-task')({
  component: ResetPasswordTaskPage,
});

function ResetPasswordTaskPage() {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.eyebrow}>Interlucent</div>
          <h1 className={styles.title}>RESET PASSWORD</h1>
          <p className={styles.subtitle}>
            Your password needs to be reset before you can continue
          </p>
        </div>
        <TaskResetPassword redirectUrlComplete="/" />
      </div>
    </div>
  );
}
